import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';

export const useMemberInfoForm = () => {
  const { setMemberInfo, getMemberInfo, removeError, selectedGender, errorsPatientDetails } =
    usePrenuvoStore(
      useShallow((state) => ({
        setMemberInfo: state.user.methods.setMemberInfo,
        getMemberInfo: state.user.methods.getMemberInfo,
        selectedGender: state.user.gender,
        errorsPatientDetails: state.user.errors,
        removeError: state.user.methods.removeError,
      })),
    );

  return { setMemberInfo, getMemberInfo, removeError, selectedGender, errorsPatientDetails };
};
